import { createTheme } from '@material-ui/core/styles';
const theme = createTheme({
  palette: {
    primary: {
      main: '#0091FF',
    },
    secondary: {
      main: '#FA6401',
    },
  },
  typography: {
    fontFamily: 'Roboto',
    defaultFontStyle: {
      fontFamily: 'Roboto',
    },
  },
  overrides: {
    // Style sheet name ⚛️
    MuiTabScrollButton: {
      // Name of the rule
      root: {
        // Some CSS
        width: '13px',
      },
    },
  },
});

export const getCustomTheme = (themeObj) => {
  const primaryColor = themeObj.primaryColor ? themeObj.primaryColor :'#0091FF'
  const secondaryColor = themeObj.secondaryColor ? themeObj.secondaryColor : '#FA6401'
  const fontFamily = themeObj.fontFamily ? themeObj.fontFamily : 'Roboto'
  const CustomTheme = createTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: secondaryColor,
      },
    },
    typography: {
      fontFamily: fontFamily,
      defaultFontStyle: {
        fontFamily: fontFamily,
      },
    },
    overrides: {
      // Style sheet name ⚛️
      MuiTabScrollButton: {
        // Name of the rule
        root: {
          // Some CSS
          width: '13px',
        },
      },
    },
  });
return CustomTheme
}
export default theme;